module.exports = __webpack_public_path__ + "img/1mdpi.5353f089.png";